<template>
  <div class="pm200">
    <img src="../../assets/img/banner.jpg" class="banner w100 cz" />
    <div>
      <div class="kjnjsfoer pd pt20">
        <p class="fz16 z3">参观日期</p>
        <van-cell title="参观日期" :value="orderInput.travelDate" @click="selectMoreDate" />
        <van-calendar v-model="showDateTimePicker" @confirm="confirmMoreDate" :min-date="minDate" :max-date="maxDate" />
        <!-- <div class="row">
          <div
            class="kjmmjknmxer cen mr15"
            v-for="(date, idx) in options.dates"
            :key="date.date"
            :class="{
              act: orderInput.travelDate === date.date,
              disabled: date.disable,
            }"
            @click="dateChanged(idx)"
          >
            <p class="fz12 z3 dfgdt">{{ date.text.substr(0, 2) }}</p>
            <div class="cen btm zts fz16 pt10" style="font-size: 14px">
              {{ date.disable ? "不可订" : date.text.substr(2) }}
            </div>
          </div>
          <div class="col">
            <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
              <p class="fz12 z3 dfgdt">更多</p>
              <div class="cen btm zts fz16 pt5">
                <i class="f_i gengdder"></i>
              </div>
            </div>
          </div>
        </div> -->
        <p class="mt15 fz16">参观区域</p>
        <van-grid
          v-if="grounds[0]"
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="ground in grounds[0].children"
            :key="ground.value"
            :name="ground.value"
          >
            <div
              class="row fgdrtwer"
              :class="[
                ground.disabled ? 'acb' : '',
                orderInput.groundId == ground.value ? 'act' : '',
              ]"
              @click="groundChange(ground)"
            >
              <div class="kmmxeert">
                <i class="f_i gounmxer" v-if="!ground.disabled"></i>
                <div v-else class="kjnmkxerse">闭<br />馆</div>
              </div>
              <div class="col pl5 pr5 z3 fz14 kmmxeert2">
                {{ ground.displayText }}
              </div>
            </div>
          </van-grid-item>
        </van-grid>
        <p class="mt15 fz16">
          入馆时段
        </p>
        <van-grid
          v-if="orderInput.groundId && changCis[0]"
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="changCi in changCis[0].children"
            :key="changCi.value"
            :name="changCi.value"
          >
            <div
              class="fgdrtwerab"
              :class="[orderInput.changCiId == changCi.value ? 'act' : '']"
              @click="changCiChange(changCi)"
            >
              <p class="fz17 z6">{{ changCi.text }}</p>
              <p class="zts fz12">{{ "(余票:" + changCi.surplusNum + ")" }}</p>
            </div>
          </van-grid-item>
        </van-grid>
        <div v-if="!orderInput.groundId" class="panel-content">
          <div class="content-text2">请先选择参观区域</div>
        </div>
      </div>
      <div class="mt10 pd">
        <p class="mt15 fz16 pm10">参观信息</p>
        <div class="row" style="margin-top:6px;margin-bottom:6px;margin-right:20px">
          <div
            class="cz col"
            style="
              color: #646566;
              margin-top: 3px;
              float: left;
              padding-left: 16px;
              padding-right: 12px;
              font-size: 14px;
            "
          >
            参观人数
          </div>
          <van-stepper
            v-model="orderInput.personNum"
            :defaultValue="0"
            :min="0"
            :max="groupOrderMaxQuantity"
            integer
            input-width="60px"
            @change="onPersonNumChange" 
          />
        </div>
      </div>
      <div class="mt10 pd" v-if="canConsumeInfos && canConsumeInfos.length>0">
        <p class="mt15 fz16 pm10">检票数量</p>
        <div class="row" style="margin-top:6px;margin-bottom:6px;margin-right:20px"
            v-for="checkGroundDto in canConsumeInfos"
            :key="checkGroundDto.groundId"
            :name="checkGroundDto.groundName">
          <div
            class="cz col"
            style="
              color: #646566;
              margin-top: 3px;
              float: left;
              padding-left: 16px;
              padding-right: 12px;
              font-size: 14px;
            "
          >
            {{checkGroundDto.groundName}}
          </div>
          <van-stepper
            v-model="checkGroundDto.canConsumeNum"
            :defaultValue="0"
            :min="0"
            :max="orderInput.personNum"
            integer
            input-width="60px" 
          />
        </div>
      </div>
      <div class="pd bgff pt15">
        <bottom-button
          text="补登"
          :loading="loading"
          @click="onSubmit"
        ></bottom-button>
      </div>
    </div>

    <van-calendar
      v-model="showDateTimePicker"
      @confirm="confirmMoreDate"
      color="#A9716D"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>
  
<script>
import moment from "moment";
import DateSelector from "@/components/DateSelector.vue";
import BottomButton from "@/components/BottomButton.vue";
import orderService from "@/services/orderService.js";
import scenicService from "@/services/scenicService.js";

export default {
  components: {
    DateSelector,
    BottomButton
  },
  data() {
    return {
      loading: false,
      orderInput: {
        travelDate: "",
        groundId: "",
        changCiId: "",
        personNum: 0
      },
      options: {
        dates: [],
        maxBookDays: 30
      },
      showDateTimePicker: false,
      grounds: [],
      changCis: [],
      canConsumeInfos: [],
    };
  },
  computed: {
    groupOrderMaxQuantity() {
      return 10000;
    },
    minDate() {
      const now = new Date();
      return new Date(now.getFullYear()-1, now.getMonth(), now.getDate());
    },
    maxDate() {
      const date = moment().add(30, "days").toDate();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
  },
  methods: {
    dateChanged(index) {
      let date = this.options.dates[index];
      if (date.disable) {
        return;
      }
      this.orderInput.travelDate = date.date;
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.orderInput.travelDate = value.format("YYYY-MM-DD");
      if (this.options.dates.filter(d => d.date == this.orderInput.travelDate).length <= 0) {
        this.options.dates[this.options.dates.length - 1] = {
          date: this.orderInput.travelDate,
          text: value.format("ddd") + value.format("MM-DD"),
          disable: false
        };
      }
    },
    setTravelDate() {
      if (this.orderInput.travelDate == "") {
        this.orderInput.travelDate = this.options.dates.filter(d => !d.disable)[0].date;
      } else {
        var temp = this.orderInput.travelDate;
        if (this.options.dates.filter((d) => d.date == temp).length > 0) {
          this.orderInput.travelDate = this.options.dates.filter(d => d.date == temp)[0].date;
        } else {
          var value = moment(temp);
          this.options.dates[this.options.dates.length - 1] = {
            date: temp,
            text: value.format("MM-DD") + value.format("ddd"),
            disable: false
          };
          this.orderInput.travelDate = this.options.dates[this.options.dates.length - 1].date;
        }
      }
    },
    groundChange(event) {
      this.orderInput.groundId = event.value;
      this.canConsumeInfos = event.groundDtos.map(o=>{
        return {groundId:o.value,groundName:o.displayText,canConsumeNum:this.orderInput.personNum};
      });
    },
    async getChangCis() {
      if (!this.orderInput.groundId) {
        return;
      }

      // if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
      //   this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
      //   if (this.wxLastBookTime) {
      //     return;
      //   }
      // }

      this.orderInput.changCiId = "";
      

      const changCis = await scenicService.getGroundChangCiItemsAsync({
        travelDate: this.orderInput.travelDate,
        groundId: this.orderInput.groundId,
        enrollOrderFlag: true
      });

      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: true, //c.disabled,
              surplusNum: c.surplusNum <= 0 ? "0" :c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];
    },
    changCiChange(event) {
      this.orderInput.changCiId = event.value;
    },
    onPersonNumChange(value) {
      this.canConsumeInfos.forEach(element => {
        element.canConsumeNum =value;
      });
    },
    async getGrounds() {
      this.orderInput.groundId = "";
      this.grounds = [
        {
          text:"区域",
          children: await scenicService.getGroundDtosAsync({travelDate: this.orderInput.travelDate}) 
        }
      ];
    },
    async onSubmit() {
      if (!this.orderInput.groundId) {
        this.$toast("请选择区域");
        return;
      }
      if (!this.orderInput.changCiId) {
        this.$toast("请选择入馆时段");
        return;
      }
      if (this.orderInput.personNum <=0 ) {
        this.$toast("请输入参观人数");
        return;
      }
      if (this.orderInput.personNum > this.groupOrderMaxQuantity) {
        this.$toast(`每单最多${this.groupOrderMaxQuantity}人`);
        return;
      }

      try {
        this.loading = true;
        this.orderInput.contactName = "13800138000";
        this.orderInput.contactMobile = "13800138000";
        this.orderInput.canConsumeInfos = this.canConsumeInfos;
        const res = await orderService.enrollOrderAsync(this.orderInput);
        if (res.success) {
          this.$router.replace({
            name: "orderinfo",
            params: {
              listNo: res.result,
              showNavbar: true
            }
          });
        }
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    "orderInput.groundId": async function (newVal) {
      try {
        this.loading = true;
        this.orderInput.changCiId = "";
        this.changCis=[];
        if (newVal) {
          await this.getChangCis();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.travelDate": async function (newVal, oldVal) {
      try {
        this.loading = true;
        this.orderInput.groundId = "";
        this.grounds = [];
        this.changCis=[];
        this.canConsumeInfos=[];
        // if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
        //   scenicService.validExceedWxLastBookTime().then((wxLastBookTime) => {
        //     this.wxLastBookTime = wxLastBookTime;
        //   });
        // }

        if (oldVal) {
          await this.getGrounds();
        }
      } finally {
        this.loading = false;
      }
    }
  },
  // watch: {
  //   "orderInput.travelDate": async function (newVal, oldVal) {
  //     this.orderInput.groundId = "";
  //     this.grounds = [];
  //     if (oldVal) {
  //       try {
  //         this.loading = true;
  //         await this.getGrounds();
  //       } finally {
  //         this.loading = false;
  //       }
  //     }
  //   }
  // },
  async created() {
    this.options = await orderService.getOrderOptionsAsync(false,false);
    this.setTravelDate();
    await this.getGrounds();
  }
};
</script>
